import React, { useContext } from "react"
import VerticalLayout from "../VerticalLayout/index"
import TableList from "../TableList/TableListUsers"
import { ServiceProvidersContext } from "./ServiceProvidersContext"

const ServiceProvidersList = () => {
  const ServiceProviderListModel = useContext(ServiceProvidersContext)
  const {
    UserTableTitle,
    serviceProviderData,
    nextPage,
    totalPagesCount,
    pageNumberThreshold,
  } = ServiceProviderListModel

  return (
    <VerticalLayout>
      <div style={{ marginTop: "70px" }}>
        <TableList
          navLocation={"/details/providerId?="}
          title={"Service Partners"}
          titleList={UserTableTitle?.titles}
          tableData={serviceProviderData}
          nextPage={nextPage}
          totalPagesCount={totalPagesCount}
          pageNumberThreshold={pageNumberThreshold}
        />
      </div>
    </VerticalLayout>
  )
}

export default ServiceProvidersList
